<template>
  <section class="pb-16" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Contáctenos</h1>
              <h3 class="font-weight-light mt-3">
                Por cualquier consulta ponte en contacto con nosotros
              </h3>
              <!-- <h3 class="font-weight-light mt-3">
                Lorem ipsum dolor sit amet consectetur adipisicing.
              </h3> -->
              <h3 class="font-weight-light mt-3">
                Teléfono: +598 98-543-209
              </h3>
              <h3 class="font-weight-light">
                Correo Electrónico: info@rms.uy
              </h3>
              <h3 class="font-weight-light mt-3">
                <v-icon x-large color="green">mdi-whatsapp</v-icon>
                <a href="https://wa.me/59898543209?text=Estoy%20interesado%20en%20saber%20mas" style="font-size: 22px">Comunícate por WhatsApp</a>
              </h3>
            </v-col>
            <v-col cols="12" sm="7">    
              <v-form ref="contactForm" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Nombre"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Correo Electrónico"
                    required
                ></v-text-field>

                <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="Mensaje"
                    required
                />

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="sendEmail"
                >
                Enviar Solicitud
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="10000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
//import {db} from '@/main'
import emailjs from '@emailjs/browser';

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "El campo nombre es obligatorio",
      (v) => (v && v.length >= 6) || "El nombre debe de ser mas de 6 caracteres",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "El campo Email es obligatorio",
      (v) => /.+@.+\..+/.test(v) || "El email debe ser valido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "El campo de mensaje es obligatorio",
      (v) => (v && v.length >= 10) || "Minimo 10 caracteres",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  
  methods: {
    sendEmail() {
      // emailjs.init({
      //   publicKey: process.env.VUE_APP_EMAILJS_PUBLIC_KEY,
      // });
      var templateParams = {
        from_name: this.name,
        reply_to: this.email,
        message: this.textArea
        },
        serviceId= process.env.VUE_APP_EMAILJS_SERVICE_ID,
        templateId= process.env.VUE_APP_EMAILJS_TEMPLATE_ID,
        publicKey= process.env.VUE_APP_EMAILJS_PUBLIC_KEY;
        // console.log(serviceId + ' ' + templateId + ' ' + publicKey);
      emailjs
        .send(serviceId, templateId, templateParams, publicKey)
        .then(
          () => {
            //console.log('SUCCESS!');
            this.snackbar.text = "Mensaje enviado con éxito, a la brevedad nos comunicaremos.";
            this.snackbar.color = "success";
            this.snackbar.enabled = true;
            this.$refs.contactForm.reset();
          },
          (error) => {
            //console.log('FAILED...', error.text);
            this.snackbar.text = "Error en el envió del mensaje, intente nuevamente!";
            this.snackbar.color = "error";
            this.snackbar.enabled = true;
          },
        );
    },
    // submit() {
    //   db.collection("contactData").add({
    //     name: this.name,
    //     email: this.email,
    //     message: this.textArea
    //   }).then(() => {
    //     this.snackbar.text = "Mensaje enviado con éxito, a la brevedad nos comunicaremos."
    //     this.snackbar.color = "success"
    //     this.snackbar.enabled = true
    //   }).catch(() => {
    //     this.snackbar.text = "Error en el envió del mensaje, intente nuevamente!"
    //     this.snackbar.color = "danger"
    //     this.snackbar.enabled = true
    //   })
    // }
  }
};
</script>
